<template>
  <div>
    <form class="verify" @submit.prevent="verifyUserPhone">
      <div class="row">
        <div class="col-12">
          <div class="font-bold">{{ $t('KW:pleaseEnterVerificationCode') }}</div>
          <b-form-input id="otp" type="number" v-model="otp" required :placeholder="$_t('KW:verificationCode')" />
          <div class="mt-2">
            <b-btn @click.prevent="requestPhoneCallVerification" sm class="btn-dark" role="button" :disabled="phoneCallRequested"
              ><i class="fa fa-phone mr-1"></i>{{ $t('KW:requestPhoneCall') }}</b-btn
            >
            <b-btn @click.prevent="resendVerificationCode" sm class="btn-dark" :disabled="resendTimer !== 0" role="button">
              <i class="fa fa-undo mr-1"></i> {{ $t('KW:resendCode') }}
              <span v-if="resendTimer !== 0"> ({{ resendTimer }}s) </span>
            </b-btn>
          </div>
        </div>

        <div v-if="errorMessage" class="ml-3 mt-2 text-danger">{{ errorMessage }}</div>

        <div class="input-group col-12 mt-4">
          <button class="btn submit" type="submit">{{ $_t('KW:verify') }}</button>
          <button class="btn btn-danger ml-3" @click="$store.dispatch('auth/logout')">{{ $_t('KW:cancelVerification') }}</button>
        </div>
      </div>
    </form>
  </div>
</template>
<script>
export default {
  data: function () {
    return {
      otp: '',
      resendTimer: 30,
      phoneCallRequested: false,
      resendTimerInterval: null,
      errorMessage: null,
    };
  },

  mounted() {
    this.setupResendTimer();
  },

  methods: {
    setupResendTimer() {
      this.resendTimerInterval = setInterval(() => {
        this.resendTimer--;
        if (this.resendTimer === 0) clearInterval(this.resendTimerInterval);
      }, 1000);
    },
    verifyUserPhone() {
      this.errorMessage = null;

      try {
        const getData = async () => {
          const verifyResp = await this.$http.post('/api/verify', { code: this.otp });
          let verifiedAt = verifyResp.data.verified_at;
          if (verifiedAt) {
            this.verificationSuccessEvent(verifiedAt);
          } else {
            this.errorMessage = this.$t('KW:errorWhileVerifyingCode');
          }
        };
        getData();
      } catch (error) {
        this.errorMessage = this.$t('KW:errorWhileVerifyingCode');
      }
    },
    verificationSuccessEvent(verifiedAt) {
      this.$store.dispatch('auth/setUserVerified', verifiedAt).catch(() => {});
      this.$store.dispatch('auth/hideModal').catch(() => {});
    },
    requestPhoneCallVerification() {
      this.$http.post('/api/send-call-verification').then(resp => {
        this.phoneCallRequested = true;
      });
    },
    resendVerificationCode() {
      this.$http.post('/api/resend-verification').then(resp => {
        this.resendTimer = 60;
        this.setupResendTimer();
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.input-group {
  .input-group-prepend .input-group-text {
    background: $dark-blue;
    border-color: $dark-blue;
    color: $white;
  }
  input {
    color: $dark-blue;
  }
}
button.submit {
  background-color: $secondary;
  border: none;
  color: $dark-blue;
  border-radius: 20px;
  padding: 8px 15px;
}

button {
  border: none;
  border-radius: 20px;
}
</style>